export default {
  en: {
    'pages.privacy-policy.title': 'Privacy Policy',
  },
};
